module.exports = __webpack_public_path__ + "img/bdd1f6a.webp";